import { action, observable } from 'mobx';
import CurrentUser from '../entity/CurrentUser';

class CurrentUserStore {
  public static generateFromApiResponse(res: any): CurrentUser {
    const id = res.id;
    const username = res.username;
    const email = res.email;
    const profileImageUrl = res.avatar_image_url;

    if (typeof id !== 'string') {
      throw new TypeError(`'res.id' must be a string, but '${res.id}' is given`);
    }
    return new CurrentUser({ id, username, email, profileImageUrl });
  }

  @observable public currentUser: CurrentUser;

  @action
  public setCurrentUser(res: any): void {
    this.currentUser = CurrentUserStore.generateFromApiResponse(res);
  }
}

export default CurrentUserStore;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/domain/store/CurrentUserStore.ts